import React, { useEffect, useRef, useState } from "react";
import { Play, CircleCheck, ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function FundamentTwojejHodowli() {
  const {
    ref: sectionRef,
    isVisible
  } = useRevealOnScroll();
  const imageRef = useRef<HTMLDivElement>(null);
  const [offsetY, setOffsetY] = useState(0);
  useEffect(() => {
    const handleScroll = () => {
      if (!imageRef.current) return;
      const scrollY = window.scrollY;
      const speed = 0.15;
      setOffsetY(scrollY * speed);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  return <section data-section-id="39212" id="czysta-instalacja-niższe-rachunki-za-ogrzewanie" ref={sectionRef} className="relative w-full overflow-hidden bg-background pt-24 pb-16 lg:pt-32 lg:pb-24 dark">
      {}
      <div className="absolute top-0 left-0 -z-10 h-full w-full overflow-hidden">
        <div className="absolute -top-[20%] -left-[10%] h-[600px] w-[600px] rounded-full bg-primary/10 blur-[120px]" />
        <div className="absolute top-[40%] -right-[10%] h-[500px] w-[500px] rounded-full bg-cyan-500/10 blur-[100px]" />
      </div>

      <div className="container mx-auto px-4 md:px-6">
        <div className="grid gap-12 lg:grid-cols-2 lg:gap-8 lg:items-center">
          {}
          <div className={`flex flex-col justify-center space-y-8 transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
            <div className="space-y-4">
              <div className="inline-flex items-center rounded-full border border-primary/20 bg-primary/10 px-3 py-1 text-xs font-mono font-semibold text-primary backdrop-blur-sm">
                <span className="flex h-2 w-2 rounded-full bg-cyan-400 mr-2 animate-pulse"></span>
                Ekspert Płukania Instalacji CO
              </div>
              
              <h1 className="text-4xl font-extrabold tracking-tighter text-foreground sm:text-5xl xl:text-6xl/none">
                Czysta instalacja –{" "}
                <span className="bg-gradient-to-r from-primary via-blue-500 to-cyan-400 bg-clip-text text-transparent">
                  niższe rachunki
                </span>
              </h1>
              
              <p className="max-w-[600px] text-lg font-medium text-muted-foreground md:text-xl leading-relaxed">Zadbaj o wydajność swojego ogrzewania i obniż koszty eksploatacji nawet o 25%. Profesjonalne płukanie i odmulanie instalacji CO dla Twojego domu.</p>
            </div>

            <div className="flex flex-col gap-4 sm:flex-row">
              <Button asChild size="lg" className="group text-base font-bold shadow-xl shadow-primary/30 bg-gradient-to-r from-primary to-cyan-500 hover:opacity-90 transition-all">
                <Link to="/ServicesPage">
                  Sprawdź Usługi
                  <ArrowRight className="ml-2 h-4 w-4 transition-transform group-hover:translate-x-1" />
                </Link>
              </Button>
              
              <Button asChild variant="outline" size="lg" className="group text-base border-primary/30 bg-background/50 backdrop-blur-md hover:bg-primary/10 hover:border-primary/50">
                
              </Button>
            </div>

            <div className="flex items-center gap-6 text-sm font-medium text-muted-foreground pt-4">
              <div className="flex items-center gap-2">
                <CircleCheck className="h-5 w-5 text-cyan-500" />
                <span>Oszczędność do 25%</span>
              </div>
              <div className="flex items-center gap-2">
                <CircleCheck className="h-5 w-5 text-cyan-500" />
                <span>Dojazd Śląsk i Małopolska</span>
              </div>
            </div>
          </div>

          {}
          <div className="relative mx-auto w-full max-w-[500px] lg:max-w-none lg:pl-10">
            {}
            <div className={`absolute top-1/2 left-1/2 -z-10 h-[110%] w-[110%] -translate-x-1/2 -translate-y-1/2 rounded-[3rem] bg-gradient-to-br from-cyan-400/20 to-transparent opacity-60 transition-all duration-1000 delay-300 ${isVisible ? "scale-100 opacity-100" : "scale-90 opacity-0"}`} />
            
            <div ref={imageRef} className={`relative overflow-hidden rounded-[2rem] border border-white/10 bg-white/5 shadow-2xl shadow-cyan-500/10 backdrop-blur-sm transition-all duration-1000 delay-150 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`} style={{
            transform: `translateY(${offsetY * -0.1}px)`
          }}>
              <div className="absolute inset-0 bg-gradient-to-t from-background/90 via-transparent to-transparent z-10" />
              
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1606250/img/realistic_heating_system.png" alt="Realistyczna ilustracja czystego systemu ogrzewania centralnego w nowym domu" className="h-full w-full object-cover object-center scale-105 hover:scale-110 transition-transform duration-700" loading="eager" />

              {}
              <div className="absolute bottom-6 left-6 z-20 rounded-xl border border-white/10 bg-background/90 p-4 backdrop-blur-xl shadow-2xl">
                <div className="flex items-center gap-3">
                  <div className="flex h-10 w-10 items-center justify-center rounded-full bg-cyan-500/20 text-cyan-400">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="h-6 w-6">
                      <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10" />
                    </svg>
                  </div>
                  <div>
                    <p className="text-[10px] font-mono font-bold uppercase tracking-wider text-cyan-400">Gwarancja</p>
                    <p className="text-sm font-bold text-foreground">100% Wydajności</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}